var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageViewHeaderWithActionBar',[_c('a',{staticClass:"item",on:{"click":_vm.save}},[_c('i',{staticClass:"icon-check-mark"})])]),_c('EditContainer',{ref:"editContainer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }